/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddParticipantsByPositionRequestDto } from '../models';
// @ts-ignore
import type { AddParticipantsBySapRequestDto } from '../models';
// @ts-ignore
import type { AddStageParticipantsResultDto } from '../models';
// @ts-ignore
import type { CertificationDetailDto } from '../models';
// @ts-ignore
import type { ChangeStageStatusRequestDto } from '../models';
// @ts-ignore
import type { CreateExamStageRequestDto } from '../models';
// @ts-ignore
import type { CreateTestStageRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * CertificationStageApi - axios parameter creator
 * @export
 */
export const CertificationStageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Finds employees by position codes and adds them as stage participants. Skips employees already assigned to the stage. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by position code
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsByPositionRequestDto} addParticipantsByPositionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipantsByPosition: async (certificationId: number, stageId: number, addParticipantsByPositionRequestDto: AddParticipantsByPositionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addStageParticipantsByPosition', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addStageParticipantsByPosition', 'stageId', stageId)
            // verify required parameter 'addParticipantsByPositionRequestDto' is not null or undefined
            assertParamExists('addStageParticipantsByPosition', 'addParticipantsByPositionRequestDto', addParticipantsByPositionRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants/by-position`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addParticipantsByPositionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds employees by SAP numbers (externalEmployeeId) and adds them as stage participants. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Unknown SAP numbers are reported with `reason = NOT_FOUND`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by SAP number
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsBySapRequestDto} addParticipantsBySapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipantsBySap: async (certificationId: number, stageId: number, addParticipantsBySapRequestDto: AddParticipantsBySapRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addStageParticipantsBySap', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addStageParticipantsBySap', 'stageId', stageId)
            // verify required parameter 'addParticipantsBySapRequestDto' is not null or undefined
            assertParamExists('addStageParticipantsBySap', 'addParticipantsBySapRequestDto', addParticipantsBySapRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants/by-sap`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addParticipantsBySapRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the status of a certification stage independently. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED, COMPLETED -> ACTIVE. Reverting from COMPLETED to ACTIVE does NOT re-open terms that were closed during the stage completion cascade — they remain in their terminal status. 
         * @summary Change stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeStageStatusRequestDto} changeStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStageStatus: async (certificationId: number, stageId: number, changeStageStatusRequestDto: ChangeStageStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('changeStageStatus', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('changeStageStatus', 'stageId', stageId)
            // verify required parameter 'changeStageStatusRequestDto' is not null or undefined
            assertParamExists('changeStageStatus', 'changeStageStatusRequestDto', changeStageStatusRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/change-status`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeStageStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new EXAM (test praktyczny) stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create EXAM stage for certification
         * @param {number} certificationId 
         * @param {CreateExamStageRequestDto} createExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExamStage: async (certificationId: number, createExamStageRequestDto: CreateExamStageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('createExamStage', 'certificationId', certificationId)
            // verify required parameter 'createExamStageRequestDto' is not null or undefined
            assertParamExists('createExamStage', 'createExamStageRequestDto', createExamStageRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/exam`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExamStageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new TEST stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create TEST stage for certification
         * @param {number} certificationId 
         * @param {CreateTestStageRequestDto} createTestStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestStage: async (certificationId: number, createTestStageRequestDto: CreateTestStageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('createTestStage', 'certificationId', certificationId)
            // verify required parameter 'createTestStageRequestDto' is not null or undefined
            assertParamExists('createTestStage', 'createTestStageRequestDto', createTestStageRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestStageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificationStageApi - functional programming interface
 * @export
 */
export const CertificationStageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificationStageApiAxiosParamCreator(configuration)
    return {
        /**
         * Finds employees by position codes and adds them as stage participants. Skips employees already assigned to the stage. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by position code
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsByPositionRequestDto} addParticipantsByPositionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStageParticipantsByPosition(certificationId: number, stageId: number, addParticipantsByPositionRequestDto: AddParticipantsByPositionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddStageParticipantsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStageParticipantsByPosition(certificationId, stageId, addParticipantsByPositionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationStageApi.addStageParticipantsByPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Finds employees by SAP numbers (externalEmployeeId) and adds them as stage participants. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Unknown SAP numbers are reported with `reason = NOT_FOUND`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by SAP number
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsBySapRequestDto} addParticipantsBySapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStageParticipantsBySap(certificationId: number, stageId: number, addParticipantsBySapRequestDto: AddParticipantsBySapRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddStageParticipantsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStageParticipantsBySap(certificationId, stageId, addParticipantsBySapRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationStageApi.addStageParticipantsBySap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes the status of a certification stage independently. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED, COMPLETED -> ACTIVE. Reverting from COMPLETED to ACTIVE does NOT re-open terms that were closed during the stage completion cascade — they remain in their terminal status. 
         * @summary Change stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeStageStatusRequestDto} changeStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStageStatus(certificationId: number, stageId: number, changeStageStatusRequestDto: ChangeStageStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStageStatus(certificationId, stageId, changeStageStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationStageApi.changeStageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new EXAM (test praktyczny) stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create EXAM stage for certification
         * @param {number} certificationId 
         * @param {CreateExamStageRequestDto} createExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExamStage(certificationId: number, createExamStageRequestDto: CreateExamStageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExamStage(certificationId, createExamStageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationStageApi.createExamStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new TEST stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create TEST stage for certification
         * @param {number} certificationId 
         * @param {CreateTestStageRequestDto} createTestStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestStage(certificationId: number, createTestStageRequestDto: CreateTestStageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestStage(certificationId, createTestStageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationStageApi.createTestStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificationStageApi - factory interface
 * @export
 */
export const CertificationStageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificationStageApiFp(configuration)
    return {
        /**
         * Finds employees by position codes and adds them as stage participants. Skips employees already assigned to the stage. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by position code
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsByPositionRequestDto} addParticipantsByPositionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipantsByPosition(certificationId: number, stageId: number, addParticipantsByPositionRequestDto: AddParticipantsByPositionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto> {
            return localVarFp.addStageParticipantsByPosition(certificationId, stageId, addParticipantsByPositionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds employees by SAP numbers (externalEmployeeId) and adds them as stage participants. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Unknown SAP numbers are reported with `reason = NOT_FOUND`. Returns counts and a per-input report of skipped items. 
         * @summary Add stage participants by SAP number
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddParticipantsBySapRequestDto} addParticipantsBySapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipantsBySap(certificationId: number, stageId: number, addParticipantsBySapRequestDto: AddParticipantsBySapRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto> {
            return localVarFp.addStageParticipantsBySap(certificationId, stageId, addParticipantsBySapRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes the status of a certification stage independently. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED, COMPLETED -> ACTIVE. Reverting from COMPLETED to ACTIVE does NOT re-open terms that were closed during the stage completion cascade — they remain in their terminal status. 
         * @summary Change stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeStageStatusRequestDto} changeStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStageStatus(certificationId: number, stageId: number, changeStageStatusRequestDto: ChangeStageStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.changeStageStatus(certificationId, stageId, changeStageStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new EXAM (test praktyczny) stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create EXAM stage for certification
         * @param {number} certificationId 
         * @param {CreateExamStageRequestDto} createExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExamStage(certificationId: number, createExamStageRequestDto: CreateExamStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.createExamStage(certificationId, createExamStageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new TEST stage within the given certification. Stage order is automatically calculated as next available. 
         * @summary Create TEST stage for certification
         * @param {number} certificationId 
         * @param {CreateTestStageRequestDto} createTestStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestStage(certificationId: number, createTestStageRequestDto: CreateTestStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.createTestStage(certificationId, createTestStageRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificationStageApi - interface
 * @export
 * @interface CertificationStageApi
 */
export interface CertificationStageApiInterface {
    /**
     * Finds employees by position codes and adds them as stage participants. Skips employees already assigned to the stage. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Returns counts and a per-input report of skipped items. 
     * @summary Add stage participants by position code
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddParticipantsByPositionRequestDto} addParticipantsByPositionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApiInterface
     */
    addStageParticipantsByPosition(certificationId: number, stageId: number, addParticipantsByPositionRequestDto: AddParticipantsByPositionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto>;

    /**
     * Finds employees by SAP numbers (externalEmployeeId) and adds them as stage participants. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Unknown SAP numbers are reported with `reason = NOT_FOUND`. Returns counts and a per-input report of skipped items. 
     * @summary Add stage participants by SAP number
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddParticipantsBySapRequestDto} addParticipantsBySapRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApiInterface
     */
    addStageParticipantsBySap(certificationId: number, stageId: number, addParticipantsBySapRequestDto: AddParticipantsBySapRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto>;

    /**
     * Changes the status of a certification stage independently. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED, COMPLETED -> ACTIVE. Reverting from COMPLETED to ACTIVE does NOT re-open terms that were closed during the stage completion cascade — they remain in their terminal status. 
     * @summary Change stage status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ChangeStageStatusRequestDto} changeStageStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApiInterface
     */
    changeStageStatus(certificationId: number, stageId: number, changeStageStatusRequestDto: ChangeStageStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * Creates a new EXAM (test praktyczny) stage within the given certification. Stage order is automatically calculated as next available. 
     * @summary Create EXAM stage for certification
     * @param {number} certificationId 
     * @param {CreateExamStageRequestDto} createExamStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApiInterface
     */
    createExamStage(certificationId: number, createExamStageRequestDto: CreateExamStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * Creates a new TEST stage within the given certification. Stage order is automatically calculated as next available. 
     * @summary Create TEST stage for certification
     * @param {number} certificationId 
     * @param {CreateTestStageRequestDto} createTestStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApiInterface
     */
    createTestStage(certificationId: number, createTestStageRequestDto: CreateTestStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

}

/**
 * CertificationStageApi - object-oriented interface
 * @export
 * @class CertificationStageApi
 * @extends {BaseAPI}
 */
export class CertificationStageApi extends BaseAPI implements CertificationStageApiInterface {
    /**
     * Finds employees by position codes and adds them as stage participants. Skips employees already assigned to the stage. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Returns counts and a per-input report of skipped items. 
     * @summary Add stage participants by position code
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddParticipantsByPositionRequestDto} addParticipantsByPositionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApi
     */
    public addStageParticipantsByPosition(certificationId: number, stageId: number, addParticipantsByPositionRequestDto: AddParticipantsByPositionRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationStageApiFp(this.configuration).addStageParticipantsByPosition(certificationId, stageId, addParticipantsByPositionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds employees by SAP numbers (externalEmployeeId) and adds them as stage participants. When the target stage is of type `EXAM`, employees without a passed TEST stage in the same certification are skipped with `reason = TEST_NOT_PASSED`. Unknown SAP numbers are reported with `reason = NOT_FOUND`. Returns counts and a per-input report of skipped items. 
     * @summary Add stage participants by SAP number
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddParticipantsBySapRequestDto} addParticipantsBySapRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApi
     */
    public addStageParticipantsBySap(certificationId: number, stageId: number, addParticipantsBySapRequestDto: AddParticipantsBySapRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationStageApiFp(this.configuration).addStageParticipantsBySap(certificationId, stageId, addParticipantsBySapRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes the status of a certification stage independently. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED, COMPLETED -> ACTIVE. Reverting from COMPLETED to ACTIVE does NOT re-open terms that were closed during the stage completion cascade — they remain in their terminal status. 
     * @summary Change stage status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ChangeStageStatusRequestDto} changeStageStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApi
     */
    public changeStageStatus(certificationId: number, stageId: number, changeStageStatusRequestDto: ChangeStageStatusRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationStageApiFp(this.configuration).changeStageStatus(certificationId, stageId, changeStageStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new EXAM (test praktyczny) stage within the given certification. Stage order is automatically calculated as next available. 
     * @summary Create EXAM stage for certification
     * @param {number} certificationId 
     * @param {CreateExamStageRequestDto} createExamStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApi
     */
    public createExamStage(certificationId: number, createExamStageRequestDto: CreateExamStageRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationStageApiFp(this.configuration).createExamStage(certificationId, createExamStageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new TEST stage within the given certification. Stage order is automatically calculated as next available. 
     * @summary Create TEST stage for certification
     * @param {number} certificationId 
     * @param {CreateTestStageRequestDto} createTestStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationStageApi
     */
    public createTestStage(certificationId: number, createTestStageRequestDto: CreateTestStageRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationStageApiFp(this.configuration).createTestStage(certificationId, createTestStageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

